import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SelectivePreloadingStrategy } from './selective-preloading-strategy';
import { AppComponent } from './app.component';

const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/'
  },
  {
    path: 'clients',
    pathMatch: 'prefix',
    component: AppComponent,
  },
  {
    path: 'clients/',
    pathMatch: 'prefix',
    redirectTo: 'clients'
  },
  {
    path: 'workouts',
    pathMatch: 'prefix',
    component: AppComponent,
  },
  {
    path: 'workouts/',
    pathMatch: 'prefix',
    redirectTo: 'workouts'

  },
  {
    path: 'articles/folders',
    pathMatch: 'prefix',
    component: AppComponent,
  },
  {
    path: 'articles',
    pathMatch: 'full',
    redirectTo: 'articles/folders'
  },
  {
    path: 'articles/',
    pathMatch: 'full',
    redirectTo: 'articles/folders'
  },
  {
    path: 'articles/item',
    pathMatch: 'prefix',
    component: AppComponent,
  },
  {
    path: 'articles/*.html',
    pathMatch: 'full',
    component: AppComponent,
  },
  {
    path: 'recipes',
    pathMatch: 'prefix',
    component: AppComponent,
  },
  {
    path: 'recipes/',
    pathMatch: 'prefix',
    redirectTo: 'recipes'

  },
  {
    path: 'login',
    component: AppComponent
  },
  { path: '**', component: AppComponent }
];
// const appRoutes: Routes = [
//   {
//     path: 'logout',
//     component: LogoutComponent
//   },
//   {
//     path: '',
//     pathMatch: 'full',
//     redirectTo: 'files'
//   },
//   {
//     path: 'files',
//     component: ListingComponent,
//     pathMatch: 'prefix',
//     children: [
//       { path:'**', component:ListingComponent},
//     ]
//   },
//   {
//     path: 'snapshots',
//     component: SnapshotsComponent
//   },
//   {
//     path: 'login',
//     component: LoginFormComponent,
//     outlet: 'login'
//   },
//   { path: '**', component: PageNotFoundComponent }
// ];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      { preloadingStrategy: SelectivePreloadingStrategy, relativeLinkResolution: 'legacy' }
    )
  ],
  exports: [
    RouterModule
  ],
  providers: [
    // CanDeactivateGuard,
    SelectivePreloadingStrategy
  ]
})
export class AppRoutingModule { }
